import React from 'react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IMenuListConfiguration, IMenuListProps, IMenuListState } from './models/index.js';
import { menuListStyle } from './styles/MenuList.style.js';
import { MENU_LIST_CATEGORY_KEY, MENU_LIST_COMPONENT_KEY } from './MenuList.meta.js';

export class MenuList extends ComponentBase<IMenuListProps, IMenuListState, IMenuListConfiguration> {
	categoryKey = MENU_LIST_CATEGORY_KEY;
	componentKey = MENU_LIST_COMPONENT_KEY;

	constructor(props: IMenuListProps) {
		super(props);
	}

	render() {
		const { className } = this.props;
		const { children, ...props } = this.componentProps;
		return (
			<ul {...props} role="group" className={className} data-selector={this.selector} tabIndex={-1}>
				{children}
			</ul>
		);
	}
}

export default InjectedStyledComponent(
	MenuList,
	MENU_LIST_CATEGORY_KEY,
	MENU_LIST_COMPONENT_KEY,
	undefined,
	undefined,
	undefined,
	menuListStyle,
);
